import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { shellRoute } from './index'
import { bookingsSearchSchema } from '../search'

export const bookingsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/bookings',
  validateSearch: bookingsSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/bookings'), 'BookingsPage'),
})
